<template>
    <div class="modal fade"  :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 590px;">
            <div class="modal-content">
                <!-- <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div> -->

                <div class="modal-body">
                    <p class="rcclConfirm-title">在享受特别订票优惠前，您需要同意下述保密条款</p>
                    <div class="rcclConfirm-content">
                        <p>本人依据优先合作伙伴计划，向皇家加勒比游轮有限公司预订优惠房间，特此承诺确认：</p>
                        <p>1.在任何情况下均不会将本次预订中所享受的优惠、折扣等信息披露给任何第三方；</p>
                        <p>2.本次预订及购买的舱房仅限我本人及直系亲属使用，在任何情况下均不会将其宣传、推广、销售给其他任何实体或个人。</p>
                        <p>如果违反前述承诺，本人将承担由此而给游轮公司造成的损失。</p>
                        <p>请选择同意，进行后续价格查询及预订操作。</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="onModalClose">不同意</button>
                        <button type="button" class="btn btn-primary" style="margin-left: 40px; width: 68px;"
                        @click="onRegisterConfirm">同意</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PartnerRulePopup",
    props: {
        isShow: {
            type: Boolean
        },
        onRegisterConfirm: {
            type: Function
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    .modal-dialog {
        top: 20%;
    }
    .rcclConfirm-title {
        margin-top: 23px;
        text-align: center;
        font-size: 20px;
        color: #006ab9;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .rcclConfirm-content {
        font-size: 14px;
        color: #747d80;
        padding: 0 35px;
        text-align: left;
        line-height: 20px;
    }
    .modal-footer {
        padding: 25px 15px 50px 15px;
        text-align: center;
        border-top: none;
        .btn, .btn:hover, .btn:focus {
            color: #282b2c;
            background-color: white;
            border: solid 1px #D3DADD;
        }
        .btn-primary, .btn-primary:hover, .btn-primary:focus {
            background-color: #fcc301;
            border-color: #fcc301;
            color: #282b2c;
        }
    }
}

.modal.active {
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}


</style>